import { render, staticRenderFns } from "./PayoffPO.vue?vue&type=template&id=5bbd4f54&scoped=true&"
import script from "./PayoffPO.vue?vue&type=script&lang=js&"
export * from "./PayoffPO.vue?vue&type=script&lang=js&"
import style0 from "./PayoffPO.vue?vue&type=style&index=0&id=5bbd4f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd4f54",
  null
  
)

export default component.exports